import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ScrollToTop from "@/components/ScrollToTop";
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import ServicesPage from "@/pages/ServicesPage";
import ContactPage from "@/pages/ContactPage";
import BlogPage from "@/pages/BlogPage";
import BlogPostPage from "@/pages/BlogPostPage";
import AdminPage from "@/pages/AdminPage";
import BookPage from "@/pages/BookPage";
import FeesPage from "@/pages/FeesPage";
import SpecialtyMiamiPage from "@/pages/SpecialtyMiamiPage";
import SpecialtyCumberlandPage from "@/pages/SpecialtyCumberlandPage";
import SpecialtyPortlandPage from "@/pages/SpecialtyPortlandPage";
import SpecialtyWashingtonDCPage from "@/pages/SpecialtyWashingtonDCPage";
import SpecialtyGroupImmersionPage from "@/pages/SpecialtyGroupImmersionPage";
import SpecialtyHyperIndependencePage from "@/pages/SpecialtyHyperIndependencePage";
import SpecialtyBoundariesTherapistPage from "@/pages/SpecialtyBoundariesTherapistPage";
import SpecialtyDisorganizedAttachmentPage from "@/pages/SpecialtyDisorganizedAttachmentPage";
import FAQPage from "@/pages/FAQPage";

function App() {
  return (
    <HelmetProvider>
      <div className="App min-h-screen flex flex-col">
        <BrowserRouter>
          <ScrollToTop />
          <Navbar />
          <main className="flex-grow">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/services" element={<ServicesPage />} />
              <Route path="/fees" element={<FeesPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/blog" element={<BlogPage />} />
              <Route path="/blog/:slug" element={<BlogPostPage />} />
              <Route path="/admin" element={<AdminPage />} />
              <Route path="/book" element={<BookPage />} />
              <Route path="/faq" element={<FAQPage />} />
              <Route path="/specialties/online-ketamine-therapy-women-miami" element={<SpecialtyMiamiPage />} />
              <Route path="/specialties/ketamine-therapy-hyper-independent-women-cumberland-maine" element={<SpecialtyCumberlandPage />} />
              <Route path="/specialties/ketamine-therapy-hyper-independent-women-portland-maine" element={<SpecialtyPortlandPage />} />
              <Route path="/specialties/ketamine-therapy-hyper-independent-women-washington-dc" element={<SpecialtyWashingtonDCPage />} />
              <Route path="/specialties/ketamine-therapy-group-immersion-fl-me" element={<SpecialtyGroupImmersionPage />} />
              <Route path="/specialties/therapy-for-hyper-independence" element={<SpecialtyHyperIndependencePage />} />
              <Route path="/specialties/boundaries-therapist-emotionally-immature-parents" element={<SpecialtyBoundariesTherapistPage />} />
              <Route path="/specialties/disorganized-attachment-kap" element={<SpecialtyDisorganizedAttachmentPage />} />
              <Route path="/specialties/ketamine-therapy-group-immersion-nj-fl-me" element={<Navigate to="/specialties/ketamine-therapy-group-immersion-fl-me" replace />} />
              <Route path="/specialties/ketamine-therapy-package-dc-residents" element={<Navigate to="/fees" replace />} />
            </Routes>
          </main>
          <Footer />
          <Toaster position="bottom-right" />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
